import { useState } from 'react';
import { useGetOrderMutation } from '@services/product/order/order.endpoints';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Order, OrderProduct } from '@services/product/order/order.types';
import { createColumnHelper } from '@tanstack/react-table';

export const useDetailsPageVM = () => {
    const { id } = useParams();
    const [order, setOrder] = useState<Order>();

    const orderProductsColumnHelper = createColumnHelper<OrderProduct>();

    const [
        getOrder,
        {
            isLoading: isGetOrderLoading,
            isUninitialized: isGetOrderUninitialized,
            isError: isGetOrderError,
            isSuccess: isGetOrderSuccess,
            error: getOrderError,
            data: getOrderResponse
        }
    ] = useGetOrderMutation();
    

    useEffect(() => {
        if (!id) return;
        getOrder({ id });
    }, [id]);

    useEffect(() => {
        if (isGetOrderLoading) return;
        if (isGetOrderError) return;
        if (getOrderError) return;

        if (isGetOrderSuccess && getOrderResponse) {
            setOrder(getOrderResponse.data);
        }
    }, [isGetOrderError, isGetOrderSuccess, getOrderError, getOrderResponse, isGetOrderLoading]);

    return {
        isLoading: isGetOrderUninitialized || isGetOrderLoading,
        isError: isGetOrderError && !order,
        order,
        orderProductsColumnHelper
    };
};
